import { useEffect, useState } from 'react';
import chroma from 'chroma-js';
import { readComputedBackground, parsePx } from './use-resolved-block-style';

function toHex(value: string | undefined): string | undefined {
  if (!value || !chroma.valid(value)) return undefined;
  const color = chroma(value);
  return color.alpha() > 0 ? color.hex() : undefined;
}

export interface ResolvedButtonStyle {
  background?: string;
  buttonColor?: string;
  textColor?: string;
  borderColor?: string;
  borderWidth?: number;
  hasBorder?: boolean;
  cornerTopLeft?: number;
  cornerTopRight?: number;
  cornerBottomRight?: number;
  cornerBottomLeft?: number;
  paddingTop?: number;
  paddingRight?: number;
  paddingBottom?: number;
  paddingLeft?: number;
}

export function useResolvedButtonStyle(blockId: string): ResolvedButtonStyle {
  const [resolved, setResolved] = useState<ResolvedButtonStyle>({});
  useEffect(() => {
    const outerCell = document.querySelector(`[data-block-id="${CSS.escape(blockId)}"]`);
    if (!outerCell) return;
    const outerComputed = getComputedStyle(outerCell);
    const buttonCell = outerCell.querySelector('td');
    const buttonComputed = buttonCell ? getComputedStyle(buttonCell) : undefined;
    const label = outerCell.querySelector('a > div');
    const labelComputed = label ? getComputedStyle(label) : undefined;

    setResolved({
      background: readComputedBackground(outerCell),
      buttonColor: toHex(buttonComputed?.backgroundColor),
      textColor: toHex(labelComputed?.color),
      borderColor: toHex(buttonComputed?.borderTopColor),
      borderWidth: buttonComputed ? parsePx(buttonComputed.borderTopWidth) : undefined,
      hasBorder: buttonComputed ? buttonComputed.borderTopStyle !== 'none' : undefined,
      cornerTopLeft: buttonComputed ? parsePx(buttonComputed.borderTopLeftRadius) : undefined,
      cornerTopRight: buttonComputed ? parsePx(buttonComputed.borderTopRightRadius) : undefined,
      cornerBottomRight: buttonComputed ? parsePx(buttonComputed.borderBottomRightRadius) : undefined,
      cornerBottomLeft: buttonComputed ? parsePx(buttonComputed.borderBottomLeftRadius) : undefined,
      paddingTop: parsePx(outerComputed.paddingTop),
      paddingRight: parsePx(outerComputed.paddingRight),
      paddingBottom: parsePx(outerComputed.paddingBottom),
      paddingLeft: parsePx(outerComputed.paddingLeft),
    });
  }, [blockId]);
  return resolved;
}
